// extracted by mini-css-extract-plugin
module.exports = {"modal":"edit-survey_modal__2k8_l","closeButton":"edit-survey_closeButton__GylQ3"};